var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowReplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 4.0830002 3.1738312",
    id: "svg1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-103.07432,-146.91308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "white"
    },
    id: "g1",
    transform: "matrix(-0.26458333,0,0,0.26458333,107.23249,146.38333)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 11.534,7 h 3.932 a 0.25,0.25 0 0 1 0.192,0.41 l -1.966,2.36 a 0.25,0.25 0 0 1 -0.384,0 L 11.342,7.41 A 0.25,0.25 0 0 1 11.534,7 m -11,2 H 4.466 A 0.25,0.25 0 0 0 4.658,8.59 L 2.692,6.23 a 0.25,0.25 0 0 0 -0.384,0 L 0.342,8.59 A 0.25,0.25 0 0 0 0.534,9",
    id: "path1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M 8,3 C 6.448,3 5.06,3.707 4.143,4.818 A 0.5,0.5 0 1 1 3.372,4.182 6.002,6.002 0 0 1 13.917,7 H 12.9 A 5,5 0 0 0 8,3 M 3.1,9 a 5.002,5.002 0 0 0 8.757,2.182 0.5,0.5 0 1 1 0.771,0.636 A 6.002,6.002 0 0 1 2.083,9 Z",
    id: "path2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "white"
    },
    id: "g2",
    transform: "matrix(0.15875,0,0,0.15875,103.91121,147.22431)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 11.596,8.697 5.233,12.389 C 4.693,12.702 4,12.323 4,11.692 V 4.308 C 4,3.678 4.692,3.298 5.233,3.612 l 6.363,3.692 a 0.802,0.802 0 0 1 0,1.393",
    id: "path1-7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowReplay);
export default __webpack_public_path__ + "static/media/arrow-replay.dd1e84e25ccddcd8a22aa47849a927a6.svg";
export { ForwardRef as ReactComponent };